import { Login } from 'components/Login';
import { LOGIN_TYPE } from 'utilities';

const ScreenLogin = () => {
  return <Login loginType={LOGIN_TYPE.DEFAULT} />;
};

export default ScreenLogin;
